"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var createPluginsConfig_exports = {};
__export(createPluginsConfig_exports, {
  default: () => createPluginsConfig
});
module.exports = __toCommonJS(createPluginsConfig_exports);
const DEFAULT_PLUGINS_PATH = "node_modules/@webplatform/frontkit/dist/plugins/";
function generateOptionalPlugins(options) {
  const optionalPluginsNameByOptions = {
    trailingSlashRedirect: { src: `${DEFAULT_PLUGINS_PATH}trailing-slash-redirect` }
  };
  return Object.keys(options).reduce((pluginsArray, optionKey) => {
    if (options[optionKey])
      pluginsArray.push(optionalPluginsNameByOptions[optionKey]);
    return pluginsArray;
  }, []);
}
;
function createPluginsConfig(options) {
  const { trailingSlashRedirect = true } = options || {};
  return [
    { src: `${DEFAULT_PLUGINS_PATH}asbis-ui` },
    { src: `${DEFAULT_PLUGINS_PATH}primevue`, mode: "client" },
    { src: `${DEFAULT_PLUGINS_PATH}scroll-lock`, mode: "client" },
    { src: `${DEFAULT_PLUGINS_PATH}vee-validate`, mode: "client" },
    { src: `${DEFAULT_PLUGINS_PATH}vue-packery`, mode: "client" },
    { src: `${DEFAULT_PLUGINS_PATH}cookie`, mode: "client" },
    { src: `${DEFAULT_PLUGINS_PATH}dev-tools`, mode: "client" },
    { src: `${DEFAULT_PLUGINS_PATH}analytics`, mode: "client" },
    { src: `${DEFAULT_PLUGINS_PATH}google-maps`, mode: "client" },
    { src: `${DEFAULT_PLUGINS_PATH}yt-frag`, mode: "client" },
    { src: `${DEFAULT_PLUGINS_PATH}cdn-image` },
    { src: `${DEFAULT_PLUGINS_PATH}i18n` },
    { src: `${DEFAULT_PLUGINS_PATH}floating-vue`, mode: "client" },
    { src: `${DEFAULT_PLUGINS_PATH}persist-utm-query-params`, mode: "client" },
    ...generateOptionalPlugins({ trailingSlashRedirect })
  ];
}
